import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Tooltip,
  useTableContext,
} from "@bleu.builders/ui";
import { DownloadCloudIcon, PlusIcon } from "lucide-react";
import React from "react";
import { useParams } from "react-router";

import { useDownloadFile } from "#/contexts/useDownload";
import { useUser } from "#/contexts/UserContext";
import { replaceParams, UserPagePath } from "#/lib/pagesHelper";
import { thesisGoupingOptions } from "#/pages/theses/(components)/ThesesGroupOptions";

import { DiagnosisReportDOCX } from "./DownloadDocument/DOCX";

export function DownloadReportDialog({ diagnosis }) {
  // @ts-expect-error TS(2339) FIXME: Property 'table' does not exist on type 'unknown'.
  const { table, isLoading, tableState } = useTableContext();
  const { user } = useUser();
  const params = useParams();

  const is_trialing =
    user.subscription?.status === "trialing" && !user.is_admin;

  const groupLabel = thesisGoupingOptions.find(
    (group) => group.value === tableState.grouping[0],
  )?.label;

  const parsed_diagnosis = diagnosis.reduce((acc, obj) => {
    acc[obj.accessorKey] = obj.value;
    return acc;
  }, {});

  const { download, isDownloading } = useDownloadFile({
    path:
      replaceParams(UserPagePath.DIAGNOSES_MATCHES, {
        diagnosis_id: params.diagnosis_id,
      }) + ".pdf",
    filename: parsed_diagnosis.title,
  });

  return (
    <Tooltip
      content={
        is_trialing
          ? "Apenas usuários com um plano ativo podem exportar relatórios"
          : isLoading
            ? "Carregando dados..."
            : ""
      }
    >
      <div>
        <Dialog>
          {/* <DialogTrigger disabled={isLoading || is_trialing}> */}
          <DialogTrigger>
            <Button
              size="sm"
              className="ml-auto hidden h-8 lg:flex"
              disabled={isLoading || is_trialing}
            >
              <PlusIcon className="mr-2 size-4" />
              Exportar relatório
            </Button>
          </DialogTrigger>
          <DialogContent className="sm:max-w-[425px]">
            <DialogHeader className="justify-start">
              <DialogTitle className="flex gap-2 items-center justify-start text-center">
                <span className="text-primary">Exportar Relatório</span>
                <DownloadCloudIcon className="text-primary size-5 font-bold" />
              </DialogTitle>
              <DialogDescription className="text-left">
                Exporte o relatório de diagnóstico para um arquivo .PDF ou .DOCX
                (WORD)
              </DialogDescription>
            </DialogHeader>
            <DialogFooter className="flex gap-1 items-start">
              <Button
                loading={isDownloading}
                loadingText="Baixando PDF"
                onClick={download}
              >
                PDF
              </Button>
              <DiagnosisReportDOCX
                table={table}
                groupLabel={groupLabel}
                diagnosis={parsed_diagnosis}
              />
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
    </Tooltip>
  );
}
